import { api } from '@api'
import { SimulationType } from '@types'

interface GetSimulationResponse {
  possibleContracts: SimulationType[]
}

interface SimulationParams {
  depotId: number
  destinationId: number
  equipmentId: number
  date: Date
  percentage: number
}

const simulate = async (params: SimulationParams) => {
  const response = await api.post<GetSimulationResponse>('/tickets/simulate', {
    ...params,
  })
  return response.data
}

export const simulationApi = { simulate }
